module.exports = __webpack_public_path__ + "assets/img/one.464140b9.png";